import axios from '../../utils/axios1'
import adminAaxios from '../../utils/axios'

// 获取广告活动组列表
export function get_ad_group_analysis(data) {
    return adminAaxios({
        url: '/admin/variety/ad_group_analysis/index',
        method: 'POST',
        data: data
    })
}

// 添加广告活动组列表
export function add_ad_group_analysis(data) {
    return adminAaxios({
        url: '/admin/variety/ad_group_analysis/add',
        method: 'POST',
        data: data
    })
}

// 删除广告活动组列表
export function delete_ad_group_analysis(data) {
    return adminAaxios({
        url: '/admin/variety/ad_group_analysis/delete',
        method: 'POST',
        data: data
    })
}

// 解析分析
export function parse_ad_group_analysis(data) {
    return adminAaxios({
        url:
            '/admin/variety/ad_group_analysis/parsing_file',
        method: 'POST',
        data: data
    })
}

// 获取断货分析列表
export function get_out_of_stock(data) {
    return adminAaxios({
        url: '/admin/variety/out_of_stock_analysis/index',
        method: 'POST',
        data: data
    })
}

// 添加断货分析数据
export function add_out_of_stock(data) {
    return adminAaxios({
        url: '/admin/variety/out_of_stock_analysis/add',
        method: 'POST',
        data: data
    })
}

// 删除断货分析数据
export function delete_out_of_stock(data) {
    return adminAaxios({
        url: '/admin/variety/out_of_stock_analysis/delete',
        method: 'POST',
        data: data
    })
}

// 解析分析
export function parse_out_of_stock(data) {
    return adminAaxios({
        url:
            '/admin/variety/out_of_stock_analysis/parsing_file',
        method: 'POST',
        data: data
    })
}

// 断货分析-得到参数
export function out_of_stock_analysis_get_config(data) {
    return adminAaxios({
        url: '/admin/variety/out_of_stock_analysis/get_config',
        method: 'POST',
        data: data
    })
}

// 断货分析-设置参数
export function out_of_stock_analysis_set_config(data) {
    return adminAaxios({
        url: '/admin/variety/out_of_stock_analysis/set_config',
        method: 'POST',
        data: data
    })
}

// 断货分析-获取箱规列表
export function out_of_stock_analysis_get_box_specification_list(data) {
    return adminAaxios({
        url: '/admin/variety/out_of_stock_analysis/get_box_specification_list',
        method: 'POST',
        data: data
    })
}

// 断货分析-导入箱规
export function out_of_stock_analysis_import_box_specification(data) {
    return adminAaxios({
        url: '/admin/variety/out_of_stock_analysis/import_box_specification',
        method: 'POST',
        data: data
    })
}

// 竞品广告分析-列表
export function variety_competing_ad_analysis_index(data) {
    return adminAaxios({
        url: '/admin/variety/competing_ad_analysis/index',
        method: 'POST',
        data: data
    })
}

// 竞品广告分析-添加记录
export function variety_competing_ad_analysis_add(data) {
    return adminAaxios({
        url: '/admin/variety/competing_ad_analysis/add',
        method: 'POST',
        data: data
    })
}

// 竞品广告分析-解析分析
export function variety_competing_ad_analysis_parsing_file(data) {
    return adminAaxios({
        url: '/admin/variety/competing_ad_analysis/parsing_file',
        method: 'POST',
        data: data
    })
}

// 竞品广告分析-删除记录
export function variety_competing_ad_analysis_delete(data) {
    return adminAaxios({
        url: '/admin/variety/competing_ad_analysis/delete',
        method: 'POST',
        data: data
    })
}


// 成本控制分析-列表
export function variety_cost_control_analysis_index(data) {
    return adminAaxios({
        url: '/admin/variety/cost_control_analysis/index',
        method: 'POST',
        data: data
    })
}

// 成本控制分析-添加记录
export function variety_cost_control_analysis_add(data) {
    return adminAaxios({
        url: '/admin/variety/cost_control_analysis/add',
        method: 'POST',
        data: data
    })
}

// 成本控制分析-解析分析
export function variety_cost_control_analysis_parsing_file(data) {
    return adminAaxios({
        url: '/admin/variety/cost_control_analysis/parsing_file',
        method: 'POST',
        data: data
    })
}

// 成本控制分析-删除记录
export function variety_cost_control_analysis_delete(data) {
    return adminAaxios({
        url: '/admin/variety/cost_control_analysis/delete',
        method: 'POST',
        data: data
    })
}

// 成本控制分析-获取基础配置数据
export function variety_cost_control_analysis_get_cost_control_message(data) {
    return adminAaxios({
        url: '/admin/variety/cost_control_analysis/get_cost_control_message',
        method: 'POST',
        data: data
    })
}

// 成本控制分析-修改基础配置数据
export function variety_cost_control_analysis_update_cost_control_message(data) {
    return adminAaxios({
        url: '/admin/variety/cost_control_analysis/update_cost_control_message',
        method: 'POST',
        data: data
    })
}

// 成本控制分析-获取类目列表
export function variety_cost_control_analysis_get_category_list(data) {
    return adminAaxios({
        url: '/admin/variety/cost_control_analysis/get_category_list',
        method: 'POST',
        data: data
    })
}




// chatgpt-提问
export function variety_chatgpt_answer(data) {
    return adminAaxios({
        url: '/admin/variety/chatgpt/answer',
        method: 'POST',
        data: data
    })
}

// chatgpt-模板列表
export function variety_chatgpt_index(data) {
    return adminAaxios({
        url: '/admin/variety/chatgpt/index',
        method: 'POST',
        data: data
    })
}

// chatgpt-模板更新|添加
export function variety_chatgpt_update(data) {
    return adminAaxios({
        url: '/admin/variety/chatgpt/update',
        method: 'POST',
        data: data
    })
}

// chatgpt-模板删除
export function variety_chatgpt_delete(data) {
    return adminAaxios({
        url: '/admin/variety/chatgpt/delete',
        method: 'POST',
        data: data
    })
}


// Asin流量差异化对比-列表
export function asin_display_amount_compare_analysis_index(data) {
    return adminAaxios({
        url: '/admin/variety/asin_display_amount_compare_analysis/index',
        method: 'POST',
        data: data
    })
}

// Asin流量差异化对比-添加记录
export function asin_display_amount_compare_analysis_add(data) {
    return adminAaxios({
        url: '/admin/variety/asin_display_amount_compare_analysis/add',
        method: 'POST',
        data: data
    })
}

// Asin流量差异化对比-解析分析
export function asin_display_amount_compare_analysis_parsing_file(data) {
    return adminAaxios({
        url: '/admin/variety/asin_display_amount_compare_analysis/parsing_file',
        method: 'POST',
        data: data
    })
}

// Asin流量差异化对比-删除记录
export function asin_display_amount_compare_analysis_delete(data) {
    return adminAaxios({
        url: '/admin/variety/asin_display_amount_compare_analysis/delete',
        method: 'POST',
        data: data
    })
}

// 成本控制分析 - 批量重置
export function variety_cost_control_analysis_batch_reset(data) {
    return adminAaxios({
        url: '/admin/variety/cost_control_analysis/batch_reset',
        method: 'POST',
        data: data
    })
}

// keepa-根类目列表(不分页)
export function keepa_keepa_root_category_list(data) {
    return adminAaxios({
        url: '/admin/keepa/keepa_root_category/list',
        method: 'POST',
        data: data
    })
}

// keepa-根类目列表(分页)
export function keepa_keepa_root_category_index(data) {
    return adminAaxios({
        url: '/admin/keepa/keepa_root_category/index',
        method: 'POST',
        data: data
    })
}

// keepa-根类目搜索
export function keepa_keepa_root_category_search(data) {
    return adminAaxios({
        url: '/admin/keepa/keepa_root_category/search',
        method: 'POST',
        data: data
    })
}

// keepa-根类目添加
export function keepa_keepa_root_category_add(data) {
    return adminAaxios({
        url: '/admin/keepa/keepa_root_category/add',
        method: 'POST',
        data: data
    })
}

// keepa-Asin排名详情
export function keepa_keepa_category_rank_statistics_index(data) {
    return adminAaxios({
        url: '/admin/keepa/keepa_category_rank_statistics/index',
        method: 'POST',
        data: data
    })
}

// keepa-添加爬取排名Asin任务
export function keepa_keepa_category_rank_statistics_add(data) {
    return adminAaxios({
        url: '/admin/keepa/keepa_category_rank_statistics/add',
        method: 'POST',
        data: data
    })
}


// keepa-添加爬取排名Asin任务
export function keepa_keepa_category_rank_statistics_task_list_add(data) {
    return adminAaxios({
        url: '/admin/keepa/keepa_category_rank_statistics_task_list/add',
        method: 'POST',
        data: data
    })
}

// 成本控制分析-导出
export function variety_cost_control_analysis_export(data) {
    return adminAaxios({
        url: '/admin/variety/cost_control_analysis/export',
        method: 'POST',
        data: data
    })
}

// keepa-分库列表
export function keepa_keepa_screen_index(data) {
    return adminAaxios({
        url: '/admin/keepa/keepa_screen/index',
        method: 'POST',
        data: data
    })
}

// keepa-分库添加
export function keepa_keepa_screen_add(data) {
    return adminAaxios({
        url: '/admin/keepa/keepa_screen/add',
        method: 'POST',
        data: data
    })
}

// keepa-分库列表相应类目
export function keepa_keepa_category_rank_statistics_get_list_category(data) {
    return adminAaxios({
        url: '/admin/keepa/keepa_category_rank_statistics/get_list_category',
        method: 'POST',
        data: data
    })
}

// keepa-更新完成的类目列表
export function keepa_keepa_root_category_get_finish_list(data) {
    return adminAaxios({
        url: '/admin/keepa/keepa_root_category/get_finish_list',
        method: 'POST',
        data: data
    })
}

// keepa-更新完成的类目列表
export function keepa_category_rank_statistics_task_list_index(data) {
    return adminAaxios({
        url: '/admin/keepa/keepa_category_rank_statistics_task_list/index',
        method: 'POST',
        data: data
    })
}

